import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import { isEventSelected, toggleEventFilter } from '../../helpers/Episode';

const Filter = ({ events, filter, setFilter }) => {
	const toggleEvent = React.useCallback(event => {
		setFilter(toggleEventFilter(events, filter, event));
	}, [events, filter, setFilter]);

	if (!events || !events.length) return null;

	return <div className="episode-filter button-bar text-end">
		{events.map(event =>
			<Button
				active={isEventSelected(filter, event)}
				key={event.id}
				onClick={() => toggleEvent(event)}
				title={event.short ? event.title : null}
				variant="outline-secondary"
			>
				{event.short || event.title}
			</Button>
		)}
	</div>;
};

Filter.propTypes = {
	events: PropTypes.arrayOf(PropTypes.shape({
	})),
	filter: PropTypes.shape(),
	setFilter: PropTypes.func,
};

export default Filter;
